function parseLocaleNumber(value) {
  if (value == null || value === '') return NaN;
  const normalized = String(value).trim().replace(/\s/g, '');
  if (normalized === '') return NaN;

  const commaIndex = normalized.lastIndexOf(',');
  const dotIndex = normalized.lastIndexOf('.');
  let sanitized = normalized;

  if (commaIndex > dotIndex) {
    sanitized = normalized.replace(/\./g, '').replace(',', '.');
  } else if (commaIndex !== -1) {
    sanitized = normalized.replace(/,/g, '');
  }

  return Number(sanitized);
}

class SearchFilters extends HTMLElement {
    constructor() {
      super();

      const _this = this;
      this._fetchAbortController = null;
      this._boundOnHistoryChange = this.onHistoryChange.bind(this);
      this.accordionType = this.dataset.accordiontype;
      this.filterParent = this.closest('#filtersCollapse');
      this.quickshop = document.querySelector('quick-shop');
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
      this.filterForm = this.querySelector('form');
  
      const toggleBtns = this.querySelectorAll('.filter__toggle');
      toggleBtns.forEach(button => button.addEventListener('click', this.toggleFilterBlock.bind(this)));
  
      /*********** Open Drawer on Filter or SortBy button click. Close Drawer on close button click *************/
      this.openFilterDrawer = document.getElementById('filter-drawer');
      if(this.openFilterDrawer) this.openFilterDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));
  
      this.openSortbyDrawer = document.getElementById('sortby-drawer');
      if(this.openSortbyDrawer) this.openSortbyDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));
  
      this.closeFilterDrawer = this.filterParent.querySelector('.search-filters-close');
      if(this.closeFilterDrawer) this.closeFilterDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));
  
      /*********** End of Open Drawer on Filter or SortBy button click. Close Drawer on close button click ********/
  
      this.sortby_values = document.querySelectorAll('[data-sortby] .sortby_options');
      this.sortby_values.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));
  
      this.filterParent.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE'){ this.closeFilterDrawer.dispatchEvent(new Event('click')); }
      });
  
      this.debouncedOnSubmit = Utility.debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
  
      if(this.filterForm){
        this.filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
        this.filterForm.addEventListener('submit', this.debouncedOnSubmit.bind(this));
        window.addEventListener('popstate', this._boundOnHistoryChange);
      }
  
      const applyBtn = this.querySelector('[data-applyFilters]');
      if(applyBtn){
        applyBtn.addEventListener('click', () => {
          this.filterForm.dispatchEvent(new Event('submit', {'bubbles' : true, 'cancelable' : true }));
          setTimeout(() => {
            this.closeFilterDrawer.dispatchEvent(new Event('click'));
          }, 1000);
        });
      }
  
      this._boundManagePagination = this._managePagination.bind(this);
      this.bindPaginationLinkEvents();
  
      this.bindActiveFilterButtonEvents();
      this.addAccessibilityAttributes(toggleBtns);
      this.colorOptionsStyling();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this._boundOnHistoryChange);
      if (this._fetchAbortController) {
        this._fetchAbortController.abort();
        this._fetchAbortController = null;
      }
    }
  
    /**
     * Filter Block Toggle event
     * @param {NodeList} toggleBtns Open filter block buttons
     */
    addAccessibilityAttributes(toggleBtns) {
      toggleBtns.forEach(element => {
        element.setAttribute('role', 'button');
        element.setAttribute('aria-expanded', false);
        element.setAttribute('aria-controls', element.nextElementSibling.id);
      });
    }
  
    /**
     * Search filter form Input event
     * @param {event} event Event Instance
     */
    onSubmitHandler(event) {
      event.preventDefault();
      if(event.type == 'input' && this.filterParent.classList.contains('filter-active')){
        return;
      }
  
      let closestForm = document.getElementById('SearchFiltersForm');
      if(event.target && event.target.closest('form')){ closestForm = event.target.closest('form'); }
      if(!closestForm) return;
      this.clampNumberInputs(closestForm);
  
      const searchParams = this._finalQueryString(closestForm)
      this.renderPage(searchParams, event);
    }

    clampNumberInputs(form) {
      form.querySelectorAll('input[type="number"]').forEach((input) => {
        const parsedValue = parseLocaleNumber(input.value);
        if (Number.isNaN(parsedValue)) return;

        const parsedMin = parseLocaleNumber(input.getAttribute('min'));
        const parsedMax = parseLocaleNumber(input.getAttribute('max'));
        let nextValue = parsedValue;

        if (!Number.isNaN(parsedMin) && nextValue < parsedMin) {
          nextValue = parsedMin;
        }
        if (!Number.isNaN(parsedMax) && nextValue > parsedMax) {
          nextValue = parsedMax;
        }

        if (nextValue !== parsedValue) {
          input.value = nextValue;
        }
      });
    }

    /**
     * click event To Remove current selections
     * @param {element} form Search page filter form
     */
     _finalQueryString(form){
      const params = new URLSearchParams();
      const formData = new FormData(form);
      formData.forEach((val, key) => {
        if (key.indexOf('price-list') >= 0) {
          const raw = String(val);
          try {
            const embedded = new URLSearchParams(raw);
            embedded.forEach((v, k) => params.append(k, v));
          } catch {
            raw.split('&').forEach((pair) => {
              const eq = pair.indexOf('=');
              if (eq === -1) return;
              params.append(pair.slice(0, eq), pair.slice(eq + 1));
            });
          }
        } else if (key.indexOf('custom_sort_by') >= 0) {
          // Hidden sort_by field carries the real param
        } else if (val != null && String(val).length > 0) {
          params.append(key, val);
        }
      });
      return params.toString();
    }
  
    /**
     * Add background color in label of Color options
     */
    colorOptionsStyling(){
      const colorSwatchContainer = this.querySelector('[data-colorFilter]');
      if(colorSwatchContainer){
        const colorSwatches = colorSwatchContainer.querySelectorAll('.color-options');
        colorSwatches.forEach(swatch => {
          let colorHandle = swatch.querySelector('input[type="checkbox"]').dataset.handle;
          let swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch.querySelector('.option-label').setAttribute('style', swatchStyle);
        });
      }
    }
  
    /**
     * click event To Remove current selections
     * @param {event} event Event Instance
     */
    onActiveFilterClick(event) {
      event.preventDefault();
      let currentTarget = event.target;
      if(!currentTarget.classList.contains('filter-option-clear')){ currentTarget = event.target.closest('.filter-option-clear')};
      this.renderPage(new URL(currentTarget.href).searchParams.toString());
    }
  
     /**
     * Update Window URL as per active filters
     * @param {event} event Event Instance
     */
    onHistoryChange(event) {
      const searchParams = event.state?.searchParams || '';
      this.renderPage(searchParams, null, false);
    }
  
    renderPage(searchParams, event, updateURLHash = true) {
      const templateSearch = document.getElementById('search-product-grid')?.querySelector('#template-search');
      if (templateSearch) templateSearch.classList.add('loading');
  
      const url = `${window.location.pathname}?${searchParams}`;
      this.renderGridFromFetch(url, 'filter');
  
      if (updateURLHash) this.updateURLHash(searchParams);
    }

    _clearGridLoading() {
      const templateSearch = document.getElementById('search-product-grid')?.querySelector('#template-search');
      if (templateSearch) templateSearch.classList.remove('loading');
    }

    /**
     * JSON templates get dynamic section IDs (e.g. template--123__main). The template JSON key "main"
     * is not always accepted by the Section Rendering API; wrong IDs return null HTML.
     * @see https://shopify.dev/docs/api/ajax/section-rendering
     */
    _getSearchSectionRequestId() {
      const templateSearch = document.getElementById('template-search');
      if (templateSearch?.dataset?.id) {
        return templateSearch.dataset.id;
      }
      const searchRoot = document.querySelector('.search-template');
      const sectionWrapper = searchRoot?.closest('[id^="shopify-section-"]');
      if (sectionWrapper?.id?.startsWith('shopify-section-')) {
        return sectionWrapper.id.slice('shopify-section-'.length);
      }
      return 'main';
    }

    renderGridFromFetch(url, type) {
      if (!url) return;
      this._setGridLoadingState(true);
      if (this._fetchAbortController) {
        this._fetchAbortController.abort();
      }
      this._fetchAbortController = new AbortController();
      const signal = this._fetchAbortController.signal;
      const sectionId = this._getSearchSectionRequestId();
      window.FilterShared.fetchSectionAwareHtml(url, sectionId, signal, 'Search')
        .then((html) => {
          if (typeof html === 'string' && html.length > 0) {
            this.renderProductGrid(html, type);
            return;
          }
          this._clearGridLoading();
          this._setGridLoadingState(false);
        })
        .catch((err) => {
          if (err.name === 'AbortError') return;
          console.error('Search filter fetch failed:', err);
          this._clearGridLoading();
          this._setGridLoadingState(false);
        });
    }
  
    renderProductGrid(html, type) {
      const innerHTML = new DOMParser().parseFromString(html, 'text/html');
      const sourceGrid = innerHTML.getElementById('search-product-grid');
      if (!sourceGrid) {
        console.error('Search refresh: missing #search-product-grid in response');
        this._clearGridLoading();
        this._setGridLoadingState(false);
        return;
      }
      const gridHTML = sourceGrid.innerHTML;
      document.getElementById('search-product-grid').innerHTML = gridHTML;

      const openFilterIndexes = Array.from(document.querySelectorAll('#main-search-filters .filter__container.open'))
        .map((openFilter) => openFilter.dataset.index)
        .filter(Boolean);

      const currentFiltersContainer = document.querySelector('.search-template__filters-container');
      const nextFiltersContainer = innerHTML.querySelector('.search-template__filters-container');
      if (currentFiltersContainer && nextFiltersContainer) {
        currentFiltersContainer.innerHTML = nextFiltersContainer.innerHTML;
      } else if (!nextFiltersContainer && currentFiltersContainer) {
        currentFiltersContainer.remove();
      } else if (nextFiltersContainer && !currentFiltersContainer) {
        const searchContent = document.querySelector('.search-template__content');
        if (searchContent) {
          searchContent.prepend(nextFiltersContainer.cloneNode(true));
        }
      }

      const currentFiltersCollapse = document.getElementById('filtersCollapse');
      const nextFiltersCollapse = innerHTML.getElementById('filtersCollapse');

      if (currentFiltersCollapse && nextFiltersCollapse) {
        currentFiltersCollapse.innerHTML = nextFiltersCollapse.innerHTML;
      } else if (currentFiltersCollapse && !nextFiltersCollapse) {
        currentFiltersCollapse.remove();
      } else if (!currentFiltersCollapse && nextFiltersCollapse) {
        const searchContent = document.querySelector('.search-template__content');
        const gridColumn = document.querySelector('#search-product-grid')?.closest('.col');
        if (searchContent && gridColumn) {
          searchContent.insertBefore(nextFiltersCollapse, gridColumn);
        }
      }

      // reopen filter blocks which are active before HTML update
      openFilterIndexes.forEach((openFilterIndex) => {
        let filterBlock = document.querySelector('.filter__container[data-index="'+openFilterIndex+'"]');
        if (!filterBlock) return;
        if(filterBlock.querySelector('.filter__toggle')){
          filterBlock.querySelector('.filter__toggle').setAttribute('aria-expanded', true);
        }
        filterBlock.classList.add('open');
        filterBlock.querySelector('.filter__block').classList.add('open');
      });
  
      const totalProducts = innerHTML.querySelector('[data-totalProducts]');
      const currentTotalProducts = document.querySelector('[data-totalProducts]');
      if (totalProducts && currentTotalProducts) {
        currentTotalProducts.innerHTML = totalProducts.innerHTML;
      }

      const productCount = innerHTML.querySelector('[data-productCount]');
      let currentProductCount = document.querySelector('[data-productCount]');
      if (productCount && currentProductCount) {
        currentProductCount.innerHTML = productCount.innerHTML;
      } else if (productCount && !currentProductCount) {
        const searchTitle = document.querySelector('.search-template__header .search-template__title');
        if (searchTitle) {
          searchTitle.insertAdjacentElement('afterend', productCount.cloneNode(true));
        }
      } else if (!productCount && currentProductCount) {
        currentProductCount.remove();
      }
      this.bindPaginationLinkEvents();
      this.bindActiveFilterButtonEvents();
      this.refreshCardActionButtons();
      this._setGridLoadingState(false);
    }

    _setGridLoadingState(isLoading) {
      window.FilterShared.setGridLoadingState('search-product-grid', isLoading);
    }

    refreshCardActionButtons() {
      window.FilterShared.refreshCardActionButtons(this.quickshop, '#search-product-grid');
    }
  
    bindActiveFilterButtonEvents() {
      document.querySelectorAll('.filter-option-clear').forEach((element) => {
        element.addEventListener('click', this.onActiveFilterClick, { once: true });
      });
    }

    bindPaginationLinkEvents() {
      window.FilterShared.bindPaginationLinkEvents(this._boundManagePagination);
    }
  
    updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
  
    updateSortBy(event){
      let _this = event.currentTarget;
      let sortBy = document.querySelector('[data-sortby] [name="custom_sort_by_mobile"]:checked');
      if(_this.name == 'custom_sort_by_desktop'){
        sortBy = document.querySelector('[data-sortby] [name="custom_sort_by_desktop"]:checked');
      }
      
      let currentvalue = sortBy.value;
      this.querySelector('[name="sort_by"]').value = currentvalue;
      this.querySelector('[name="sort_by"]').dispatchEvent(new Event('input', {
        bubbles: true,
        cancelable: true,
      }));
    }
  
    _managePagination(event){
      event.preventDefault();
      let _this = event.currentTarget;
      const nextPageLink = _this.href;
      this.scrollToResultsTop();
      this.renderGridFromFetch(nextPageLink, 'pagination');
  
      setTimeout(() => {
        history.pushState({}, '', nextPageLink);
      }, 500);
    }

    scrollToResultsTop() {
      window.FilterShared.scrollToResultsTop('.search-template__header', '#search-product-grid', 'smooth');
    }
  
    toggleFilterDrawer(event){
      event.preventDefault();
      let button = event.currentTarget;
      if(button.id == 'filter-drawer' || button.id == 'sortby-drawer'){
        this.filterParent.classList.add('filter-active');
        button.setAttribute('aria-expanded', true);
        button.setAttribute('tabindex', '-1');
  
        if(button.id == 'sortby-drawer'){ this.filterParent.classList.add('sortby-drawer'); }
        else{ this.filterParent.classList.remove('sortby-drawer'); }
  
        Utility.trapFocus(this.filterParent);
        Utility.forceFocus(this.closeFilterDrawer);
        siteOverlay.prototype.showOverlay();
      }else{
        this.filterParent.classList.remove('filter-active');
        this.filterParent.classList.remove('sortby-drawer');
        if(this.openFilterDrawer){
          this.openFilterDrawer.setAttribute('aria-expanded', false);
          this.openFilterDrawer.removeAttribute('tabindex');
        }if(this.openSortbyDrawer){
          this.openSortbyDrawer.setAttribute('aria-expanded', false);
          this.openSortbyDrawer.removeAttribute('tabindex');
        }
  
        Utility.removeTrapFocus(this.filterParent);
        siteOverlay.prototype.hideOverlay();
      }
    }
  
    toggleFilterBlock(event) {
      event.preventDefault();
      const toggleFilterBtn = event.currentTarget;
      const filterContainer = toggleFilterBtn.parentNode;
      const isOpen = filterContainer.classList.contains('open');
      isOpen ? this.closeFilterBlock(toggleFilterBtn) : this.openFilterBlock(toggleFilterBtn);
    }
  
    openFilterBlock(toggleFilterBtn){
      let filterContainer = toggleFilterBtn.parentNode;
      toggleFilterBtn.setAttribute('aria-expanded', true);
      Utility.toggleElement(filterContainer, 'open');
      if(this.accordionType == 'single'){
        let siblingBlocks = filterContainer.parentNode.querySelectorAll('.filter__container');
        siblingBlocks.forEach(element => {
          if(element == filterContainer){ return; }
          element.classList.remove('open');
          element.querySelector('.filter__block').classList.remove('open');
          element.querySelector('.filter__toggle').setAttribute('aria-expanded', false);
        });
      }
      Utility.trapFocus(filterContainer);
    }
  
    closeFilterBlock(toggleFilterBtn){
      const filterContainer = toggleFilterBtn.parentNode;
      toggleFilterBtn.setAttribute('aria-expanded', false);
      Utility.toggleElement(filterContainer, 'close');
      Utility.removeTrapFocus(filterContainer);
    }
  }
  customElements.define('search-filters', SearchFilters);

  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('input')
        .forEach((element) => {
          element.addEventListener('change', this.onRangeChange.bind(this));
          element.addEventListener('blur', this.onRangeChange.bind(this));
        });
  
      this.setMinAndMaxValues();
    }
  
    onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
      const inputs = this.querySelectorAll('input');
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute('max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }

    adjustToValidValues(input) {
      const value = parseLocaleNumber(input.value);
      if (Number.isNaN(value)) return;

      const min = parseLocaleNumber(input.getAttribute('min'));
      const max = parseLocaleNumber(input.getAttribute('max'));
      if (!Number.isNaN(min) && value < min) input.value = min;
      if (!Number.isNaN(max) && value > max) input.value = max;
    }
  }
  customElements.define('price-range', PriceRange);